<!--
Voting election selection screen
@author ab557z
-->
<template>
  <div id="contain" class="container">
  <Nav name="Elections" :step="1!==1" />
  <div class="vContainer">
      <div style="text-align:center;margin-top:35vh;" v-if="noElections">
              <p style="color:#4F5961">Sorry, you don't have elections to vote for.</p>
      </div>
      <div v-for="(electionInfo, electionType) in values" :key="electionType">
        <p class="votingCatHdr">{{electionType}}</p>
        <div class="list-group">
          <router-link v-for="election in electionInfo" :key="election.electionId" :to="'/voting/ballotbox?electionId=' + election.electionId" class="list-group-item electionLink" style="margin-bottom:10px;">
              <font-awesome-icon style="margin-top:6px;" icon="arrow-right" size="sm" class="menuChev"></font-awesome-icon>
              {{election.name}}
          </router-link>
        </div>
      </div>
  </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'VotingElection',
  data () {
    return {
      values: {},
      noElections: false
    }
  },

  mounted () {
    axios.get('/vote/rest/election')
      .then(response => {
        this.values = {}
        this.values = response.data
        if (Object.keys(this.values).length === 0) {
          this.noElections = true
        }
      })
  },
  methods: {
  }
}
</script>
<style>
.electionLink {
  background-color:rgba(0, 56, 101, 0.1) !important;
  color:#003865;
  font-weight:bold;
  border: 1px solid #e4e4e4 !important;
  border-radius: 24px !important;
}

.electionLink p {
  overflow:hidden;
}

.votingCatHdr {
  margin-top:24px;
  margin-bottom:16px;
  font-weight:bold;
  color: #003865; /* #686868 */
}

#emptyVote {
  border-radius:1px solid #00B5D1;
  background-color:#ffffff;
  color:#003865;
}
</style>
